<template>
  <div class="device-verify">
    <CommonContent>
      <div class="search-box">
        <input v-model="value" class="search-input" placeholder="请输入认证查询编号" />
      </div>
      <div class="search-btn" @click="handleSearch">
        查&nbsp;询
      </div>
      <div class="tip">
        <!-- <div class="left">
          <div class="desc">
            输入认证服务商编号
          </div>
          <img src="~images/right-icon.svg" />
        </div>
        <div class="line">
        </div>
        <div class="right">
          <div class="desc">
            点击查询按钮
          </div>
          <img src="~images/right-icon.svg" />
        </div> -->
      </div>
    </CommonContent>
  </div>
</template>

<script>
import CommonContent from '@/components/CommonContent.vue'
import { queryEquipmentInfo } from '@/api/common'
export default {
  name: 'DeviceVerify',
  components: {
    CommonContent
  },
  data() {
    return {
      value: ''
    }
  },
  methods: {
    handleSearch() {
      if (!this.value) return
      queryEquipmentInfo(this.value).then(res => {
        let { content, success, errorType } = res.data
        if (success && errorType === '00000000') {
          if (!content) {
            alert('您输入的认证服务商信息不存在，谨防假冒。')
          } else {
            this.$router.push({ path: '/deviceVerifyResult', query: { code: this.value }})
          }
        } else {
          alert('查询失败，请稍后再试！')
        }
      }).catch(() => {
        alert('查询失败，请稍后再试！')
      })
    }
  }
}
</script>

<style lang="less" scopeds>
.device-verify{
  width: 100%;
  height: 100%;
  .search-box{
    width: 590px;
    height: 100px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #659BF6 0%, #3E67F4 100%);
    border-radius: 10px;
    .search-input{
      width: 570px;
      height: 80px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 0;
      padding: 0 32px;
      box-sizing: border-box;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333;
    }
  }
  .search-btn{
    margin: 15px auto 60px;
    width: 205px;
    height: 85px;
    text-align: center;
    line-height: 75px;
    background: url('~images/search-btn.png') no-repeat left top;
    background-size: 100% 100%;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 700;
    color: #FFFFFF;
    -webkit-text-stroke: 2px #4EA3F3;
  }
  .tip{
      width: 623px;
      height: 108px;
      margin: auto;
      // background: linear-gradient(-1deg, #789EF5, #6F98F3, #9AC3FF);
      border-radius: 14px;
      display: flex;
      align-items: center;
      background: url('~images/device-verify.png') no-repeat left top;
      background-size: 100% 100%;
      .left{
        width: 360px;
        height: 100%;
        display: flex;
        align-items: center;
        .desc{
          padding: 0 16px 0 31px;
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
        >img{
          width: 24px;
          margin-top: 5px;
        }
      }
      .line{
        width: 1px;
        height: 50px;
        background: #91B8FE;
      }
      .right{
        flex: 1;
        display: flex;
        align-items: center;
        .desc{
          padding: 0 16px 0 24px;
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
        >img{
          width: 24px;
          margin-top: 5px;
        }
      }
  }
}
</style>
